'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.aggregate-error');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.aggregate-error.js
// module id = 734
// module chunks = 13